import { NgIf, NgSwitch, NgSwitchCase } from '@angular/common';
import { Component } from '@angular/core';
import { AxisCursorComponent } from '@modules/cursors/components/axis-cursor/axis-cursor.component';
import { CircleCursorComponent } from '@modules/cursors/components/circle-cursor/circle-cursor.component';
import { CircleTextCursorComponent } from '@modules/cursors/components/circle-text-cursor/circle-text-cursor.component';
import { DotCursorComponent } from '@modules/cursors/components/dot-cursor/dot-cursor.component';
import { FluidCursorComponent } from '@modules/cursors/components/fluid-cursor/fluid-cursor.component';
import { CursorService } from '@modules/cursors/services/cursor.service';
import { CursorType } from '@modules/cursors/types/cursor-type';
import { LoaderHelper } from '@modules/loaders/helpers/loader-helper';

@Component({
  selector: 'app-cursors-wrapper',
  templateUrl: './cursors-wrapper.component.html',
  styleUrls: ['./cursors-wrapper.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    NgSwitch,
    FluidCursorComponent,
    NgSwitchCase,
    CircleCursorComponent,
    AxisCursorComponent,
    CircleTextCursorComponent,
    DotCursorComponent,
  ],
})
export class CursorsWrapperComponent extends LoaderHelper {
  cursor: CursorType;

  constructor(cursorService: CursorService) {
    super();

    cursorService.cursor.subscribe(cursor => {
      this.cursor = cursor;
    });
  }
}
